/**
 * Files the backend puts at the root of every solution repository that are not the
 * solution's configuration: gitea's `README.md` and the default `stopwords.json`
 * (`DEFAULT_STOPWORDS_PATH` in the backend's agent-manager constants).
 *
 * Files → Configuration lists that root (`configsFiles` reads `filePath: '/'`), so they are
 * hidden there (PSTUDIO-4354). Root only and exact case: a `README.md` inside a folder is
 * the user's own.
 */
const SCAFFOLDING_FILES = new Set(['README.md', 'stopwords.json']);

export const isRepositoryScaffoldingFile = (path: string): boolean =>
  SCAFFOLDING_FILES.has(path.replace(/^\/+/, ''));
